module.exports = __webpack_public_path__ + "img/18.3953b656.png";